import { TextInput, required, maxLength } from "react-admin";
import { Grid } from "@mui/material";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Име"
          source="name"
          validate={[required(), maxLength(200)]}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Секция"
          source="section"
          validate={[maxLength(200)]}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};
export default SaveForm;
